import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
import "./brand.css";
import "./navigation.css";
import "./hero-page.css";
import "./readability-overlap-fix.css";
import "./hero-closing-section.css";
import "./messaging.css";
import "./contact.css";
import "./pricing.css";
import "./about.css";
import "./remote-access.css";
import "./legal.css";
import "./my-space.css";
import "./ticketing.css";
import "./header-consistency.css";
import "./breadcrumbs.css";
import "./home-section-spacing.css";
import "./hero-subheading-consistency.css";
import "./responsive-overrides.css";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

